module.exports = __webpack_public_path__ + "media/images/undraw/shift/firmware-d9ca5f94f402c22046891922feac4ad9.png";